module.exports = __webpack_public_path__ + "img/logo_green_creative.027ad68f.png";